import { render, staticRenderFns } from "./StrategyCard.vue?vue&type=template&id=2d55703b&scoped=true&"
import script from "./StrategyCard.vue?vue&type=script&lang=js&"
export * from "./StrategyCard.vue?vue&type=script&lang=js&"
import style0 from "./StrategyCard.vue?vue&type=style&index=0&id=2d55703b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d55703b",
  null
  
)

export default component.exports